import React, { createContext, useEffect, useState } from 'react'
import { Outlet } from "react-router-dom";
import styled from 'styled-components';

import { Spinner } from 'react-bootstrap';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useAuth } from '@frontegg/react';
import AuthService, { AuthProvider, AuthServiceState, useFullAuthState } from '@services/auth/auth.service';
import { FullPageLoader } from '@components/loaders/FullPageLoader.component';


const Main = styled.main`
    height: 100%;
    width: 100%;
`


const UnauthenticatedRootPage = () => {

    return (
        <GoogleReCaptchaProvider reCaptchaKey="6LcasCApAAAAAJTRvrhKnT1kzAzvNPOMZOqMg-Y5">
            <Main>
                <Outlet/>
            </Main>
        </GoogleReCaptchaProvider>
        
    );
}

export default UnauthenticatedRootPage;